import { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { gaUtil, taUtil, isIthClient } from "@/utils";

type Props = {
  /**
   * 基本标题，默认为 'ITH工作台'
   */
  baseTitle?: string;

  /**
   * 页面标题，与 baseTitle 通过 '-' 连接后展示。例: pageTitle = '今天'，则 title = '今天 - ITH工作台'
   */
  pageTitle?: string;

  /**
   * 是否开启报告
   */
  report?: boolean;
}

export const IthHelmet: React.FC<Props> = (props) => {
  const {
    baseTitle =  isIthClient() ? 'ITH工作台' : 'PLM',
    pageTitle,
    report = false
  } = props;

  const fullTitle = useMemo(() => {
    if (!pageTitle) return baseTitle;
    return [pageTitle, baseTitle].join(' - ');
  }, [baseTitle, pageTitle]);

  useEffect(() => {
    if (report) {
      gaUtil.pageview(fullTitle);
      taUtil.pageview(fullTitle);
    }
  }, [fullTitle, report]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};
